<template>
  <div class="modal">
    <div class="popup-content">
      <div class="popup-header">
        <h3>Item Details</h3>
        <button @click="closeModal" class="btn btn-light close-btn">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      <div class="popup-body">
        <div class="popup-columns">
          <div class="popup-column details-column">
            <div class="item-image-container">
              <img
                :src="imageSrc"
                alt="Item Image"
                class="item-image"
                @error="onImageError"
              />
            </div>

            <p><strong>Item Name:</strong> {{ itemDetails.item_name }}</p>
            <p><strong>Category:</strong> {{ itemDetails.item_category }}</p>
            <p><strong>SAP Code:</strong> {{ itemDetails.sap_code }}</p>
            <p><strong>Is Returned:</strong> {{ itemDetails.is_returned === '1' ? 'Yes' : 'No' }}</p>
            <p><strong>Status:</strong>
              <span :class="statusClass(itemDetails.status)">
                {{ itemDetails.status === '1' ? 'ACTIVE' : 'INACTIVE' }}
              </span>
            </p>
          </div>

          <div class="popup-column prices-column">
            <h5>Item Price</h5> <br>
            <div class="variant-tabs">
              <button
                  v-for="(variant, index) in itemVariants"
                  :key="variant.details.id"
                  :class="['tab-btn', { active: selectedVariantIndex === index }]"
                  @click="selectedVariantIndex = index"
                  class="price-tabs"
              >
                {{ variant.details.variant_name }}
              </button>
            </div>

            <div class="price-table" v-if="selectedVariant && selectedVariant.prices.length">
              <table class="table-container">
                <thead>
                  <tr class="first-row">
                    <th rowspan="2">District</th>
                    <th rowspan="2">Cost (Rs.)</th>
                    <th colspan="2">Distributor Price (Rs.)</th>
                    <th colspan="2">Dealer Price (Rs.)</th>
                    <th colspan="2">Consumer Price (Rs.)</th>
                  </tr>
                  <tr class="second-row">
                    <th>Without VAT</th>
                    <th>With VAT</th>
                    <th>Without VAT</th>
                    <th>With VAT</th>
                    <th>Without VAT</th>
                    <th>With VAT</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(price, i) in selectedVariant.prices" :key="i">
                    <td>{{ price.district_name }}</td>
                    <td>{{ price.cost }}</td>
                    <td>{{ price.distributor_price }}</td>
                    <td>{{ price.distributor_price_with_vat }}</td>
                    <td>{{ price.dealer_price }}</td>
                    <td>{{ price.dealer_price_with_vat }}</td>
                    <td>{{ price.consumer_price }}</td>
                    <td>{{ price.consumer_price_with_vat }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="no-prices-message">
              <p>No price data available for this variant.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ItemDetailsModal",
  props: {
    itemDetails: {
      type: Object,
      required: true
    },
    itemVariants: {
      type: Array,
      required: true
    }
  },
  emits: ['close-modal'],
  data() {
    return {
      selectedVariantIndex: 0,
      imageError: false
    };
  },
  computed: {
    selectedVariant() {
      return this.itemVariants[this.selectedVariantIndex] || { prices: [] };
    },
    imageSrc() {
      // --- FIX IS HERE ---
      if (this.itemDetails.item_image && !this.imageError) {
        const base64Data = this.itemDetails.item_image.trim();
        
        // Check if the string already contains the Data URI prefix
        if (base64Data.startsWith('data:image')) {
          return base64Data;
        }
        
        // Otherwise, prepend the required prefix for rendering
        return `data:image/png;base64,${base64Data}`;
      } else {
        const text = encodeURIComponent(this.itemDetails.item_name || 'Item Image Not Found');
        return `https://www.dummyimg.in/placeholder?width=300&height=200&text=${text}&text_color=%23000000&bg_color=%23cccccc&font_size=18&text_position=center&font_style=arial`;
      }
    }
  },
  mounted() {
    document.body.style.overflow = 'hidden';
  },
  beforeUnmount() {
    document.body.style.overflow = '';
  },
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
    onImageError() {
      this.imageError = true;
    },
    statusClass(status) {
      if (status === "0") return 'badge badge-cancel';
      if (status === "1") return 'badge badge-active';
      return 'badge badge-secondary';
    }
  }
};
</script>

<style scoped>
/* Keeping your existing styles exactly as they were */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.popup-content {
  width: 100vw;
  height: 100vh;
  background-color: white;
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
}

.close-btn {
  border-radius: 50%;
  width: 33px;
  height: 33px;
  padding: 0;
  cursor: pointer;
  font-size: 18px;
}

.popup-columns {
  display: flex;
  gap: 20px;
}

.popup-column {
  display: flex;
  flex-direction: column;
}

.details-column {
  width: 30%;
  padding-right: 5px;
  border-right: 1px solid #ccc;
}

.item-image-container {
  text-align: left;
  margin-bottom: 15px;
}

.item-image {
  max-width: 100%;
  max-height: 150px;
  border-radius: 8px;
  object-fit: contain;
}

.prices-column {
  width: 70%;
  padding-left: 10px;
}

.variant-tabs {
  margin-top: -10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.price-tabs {
  padding: 5px 10px;
  cursor: pointer;
  background-color: #f4f4f4;
  border: 1px solid #ddd;
  border-radius: 10px 5px;
  white-space: nowrap;
  flex-shrink: 0;
}

.price-tabs.active {
  background-color: #007BFF;
  color: white;
  border-color: #007BFF;
}

.price-table, .no-prices-message {
  margin-top: 20px;
}

.table-container table {
  width: max-content;
}

.table-container thead {
  background-color: #f4f4f4;
}

.table-container th {
  text-align: left;
  border: 1px solid #ddd;
  background-color: #f4f4f4;
  padding: 10px;
}

.table-container td {
  text-align: left;
  border: 1px solid #ddd;
  padding: 10px;
}

.table-container thead .first-row th {
  text-align: center;
}

.table-container thead .second-row th {
  font-size: 12px;
  color: #888;
  text-align: center;
}

.badge-cancel {
  background-color: #dc3545;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
}

.badge-active {
  background-color: #28a745;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
}

.badge-secondary {
  background-color: #6c757d;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
}
</style>